import { Map, List } from 'immutable';
/**
 * Global state
 *
 * @export
 * @class GlobalState
 */
var GlobalState = /** @class */ (function () {
    function GlobalState() {
        /**
         * Set percent of loading progress and visibility for Master component
         *
         * @type {{
         *     percent: number,
         *     visible: boolean
         *   }}
         * @memberof IGlobalState
         */
        this.progress = Map({
            percent: 0,
            visible: false
        });
        /**
         * If loading is enabled {true} or not false
         *
         * @type {boolean}
         * @memberof IGlobalState
         */
        this.loadingStatus = true;
        /**
         * Whether send feedback is diplayed
         */
        this.sendFeedbackStatus = false;
        /**
         * If user date is loaded {true} or not {false}
         *
         * @type {boolean}
         * @memberof IGlobalState
         */
        this.defaultLoadDataStatus = false;
        /**
         * If message popup is open {true} or not {false}
         *
         * @type {boolean}
         * @memberof IGlobalState
         */
        this.messageOpen = false;
        /**
         * The text of popup global message
         *
         * @type {string}
         * @memberof IGlobalState
         */
        this.message = '';
        /**
         * Window size
         *
         * @type {number}
         * @memberof IGlobalState
         */
        this.windowWidth = 0;
        /**
         * Window height
         *
         * @type {number}
         * @memberof IGlobalState
         */
        this.windowHeight = 0;
        /**
         * The text of website header
         *
         * @type {string}
         * @memberof IGlobalState
         */
        this.headerTitle = '';
        /**
         * Top loading is visible {true} or not {false}
         *
         * @type {boolean}
         * @memberof IGlobalState
         */
        this.showTopLoading = false;
        /**
         * Top loading message queue
         *
         * @type {number}
         * @memberof IGlobalState
         */
        this.topLoadingQueue = 0;
        /**
         * Master loading is visible {true} or not {false}
         *
         * @type {boolean}
         * @memberof IGlobalState
         */
        this.showMasterLoading = true;
        /**
         * Master loading message queue
         *
         * @type {number}
         * @memberof IGlobalState
         */
        this.masterLoadingQueue = 0;
        this.justin = 13;
        /**
         * Temp date storage
         *
         * @type {*}
         * @memberof IGlobalState
         */
        this.temp = Map({
            caller: List()
        });
    }
    return GlobalState;
}());
export { GlobalState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/global/GlobalState.ts
// module id = 561
// module chunks = 50